enum AddressSearchMode {
	ZIP_CODE = 'zipCode',
	CURRENT_LOCATION = 'currentLocation',
}

type AddressSearchTypeSelectorProps = {
	selectedMode: AddressSearchMode;
	onModeChange: (mode: AddressSearchMode) => void;
	isLocating?: boolean;
	isLocationBlocked?: boolean;
};

export {AddressSearchMode};
export type {AddressSearchTypeSelectorProps};
